export default {
  title: "Wallet картасының дизайны",
  emptyState: {
    pageUnavailable: "Бет әлі қолжетімді емес",
    description:
      "Бетке қол жеткізу үшін «Промо» немесе «Про+» тарифін сатып алу қажет",
    buttonText: "Тарифтерге өту",
  },
  tradingPoint: "Сауда нүктесі",
  actions: {
    resetDesign: "Негізгі дизайнға қайтару",
    saveChanges: "Өзгерістерді сақтау",
  },
  walletCardPreview: {
    clientName: "Клиенттің аты",
    balance: "Баланс",
    discount: "Жеңілдік",
  },
  walletCardSettings: {
    colors: {
      title: "Wallet картасының түстері",
      background: "Фон түсі",
      text: "Мәтін түсі",
    },
    logo: {
      title: "Мекеменің логотипі",
      noLogo: "Логотип жоқ",
      hasLogo: "Логотип бар",
      aspectRatio: "Логотиптің арақатынасы — 1:1",
      fileRequirements: "PNG, JPG, JPEG — 1 файл, 5 МБ-қа дейін",
    },
    stripe: {
      title: "Астыңғы сурет",
      noStripe: "Астыңғы сурет жоқ",
      image: "Сурет",
      colorFill: "Түспен толтыру",
      aspectRatio: "Арақатынас — 3:1",
      fileRequirements: "PNG, JPG, JPEG — 1 файл, 5 МБ-қа дейін",
      color: "Астыңғы суреттің түсі",
    },
  },
};
